/* ==========================================================================
   Zapatos Obi — facets.js
   Filtros y orden de colección sin recargar:
   - El form #FacetsForm funciona también sin JS (GET clásico).
   - Con JS: serializa el form, pide la misma URL con section_id (Section
     Rendering API), reemplaza el grid y actualiza la URL (history API).
   ========================================================================== */
(function () {
  'use strict';

  var root = null;
  var form = null;
  var grid = null;
  var sectionId = null;
  var controller = null;
  var priceTimer = null;

  function init() {
    root = document.getElementById('CollectionRoot');
    if (!root) return;
    form = document.getElementById('FacetsForm');
    grid = document.getElementById('ProductGridContainer');
    sectionId = root.getAttribute('data-section-id');
    if (!grid || !sectionId) return;

    initDrawer();
    initInfinite();
    initPillsScroll();

    if (form) {
      form.addEventListener('change', onFormChange);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        applyFilters();
      });
      /* slider de precio: visual en vivo + sincronizar casillas */
      form.addEventListener('input', function (e) {
        if (e.target.matches('[data-range-min], [data-range-max]')) {
          syncPriceSlider(e.target);
        }
      });
      syncAllSliders();
    }

    /* Chips de filtros activos y paginación: navegación AJAX también */
    grid.addEventListener('click', function (e) {
      var link = e.target.closest('.facets__chip, .facets__clear, .pagination__item[href]');
      if (!link || !link.getAttribute('href')) return;
      e.preventDefault();
      renderFromUrl(link.getAttribute('href'), true);
    });

    window.addEventListener('popstate', function () {
      renderFromUrl(window.location.href, false);
    });
  }

  /* ---------- Slider de precio (doble tirador) ---------- */
  function syncPriceSlider(changed) {
    var wrap = changed.closest('[data-price-slider]');
    if (!wrap) return;
    var minR = wrap.querySelector('[data-range-min]');
    var maxR = wrap.querySelector('[data-range-max]');
    var fill = wrap.querySelector('[data-slider-fill]');
    var top = parseFloat(wrap.getAttribute('data-max')) || 100;

    var lo = parseFloat(minR.value);
    var hi = parseFloat(maxR.value);
    /* evitar cruce de tiradores */
    if (lo > hi) {
      if (changed === minR) {
        minR.value = hi;
        lo = hi;
      } else {
        maxR.value = lo;
        hi = lo;
      }
    }

    if (fill) {
      fill.style.left = (lo / top) * 100 + '%';
      fill.style.right = 100 - (hi / top) * 100 + '%';
    }

    /* sincronizar casillas numéricas (sin disparar el filtrado) */
    var price = wrap.parentElement.querySelector('.facets__price');
    if (price) {
      var inputs = price.querySelectorAll('input[type="number"]');
      if (inputs[0]) inputs[0].value = lo > 0 ? lo : '';
      if (inputs[1]) inputs[1].value = hi < top ? hi : '';
    }
  }

  function syncAllSliders() {
    if (!form) return;
    form.querySelectorAll('[data-price-slider] [data-range-min]').forEach(function (r) {
      syncPriceSlider(r);
    });
  }

  /* ---------- Scroll infinito ---------- */
  var io = null;
  var loadingMore = false;

  function initInfinite() {
    if (root.getAttribute('data-infinite') !== 'true') return;
    if (!('IntersectionObserver' in window)) return;
    root.classList.add('infinite-on');
    attachInfiniteObserver();
  }

  function attachInfiniteObserver() {
    if (!root.classList.contains('infinite-on')) return;
    if (io) io.disconnect();
    var target = grid.querySelector('.pagination');
    if (!target || !grid.querySelector('.pagination a[rel="next"]')) return;
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) loadNextPage();
        });
      },
      { rootMargin: '800px 0px' }
    );
    io.observe(target);
  }

  function infiniteLoader(show) {
    var loader = grid.querySelector('.collection__loader');
    if (!loader && show) {
      loader = document.createElement('div');
      loader.className = 'collection__loader';
      loader.setAttribute('aria-label', 'Cargando');
      grid.appendChild(loader);
    }
    if (loader) loader.hidden = !show;
  }

  function loadNextPage() {
    if (loadingMore) return;
    var nextLink = grid.querySelector('.pagination a[rel="next"]');
    if (!nextLink) return;
    loadingMore = true;
    if (io) io.disconnect();
    infiniteLoader(true);

    var u = new URL(nextLink.getAttribute('href'), window.location.origin);
    u.searchParams.set('section_id', sectionId);

    fetch(u.toString())
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#ProductGridContainer .product-grid');
        var curGrid = grid.querySelector('.product-grid');
        if (newGrid && curGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (li) {
            curGrid.appendChild(li);
          });
        }
        var curPag = grid.querySelector('.pagination');
        var newPag = doc.querySelector('#ProductGridContainer .pagination');
        if (curPag) {
          if (newPag) curPag.replaceWith(newPag);
          else curPag.remove();
        }
        infiniteLoader(false);
        loadingMore = false;
        attachInfiniteObserver();
        if (window.ObiWishlist) window.ObiWishlist.sync(grid);
      })
      .catch(function () {
        infiniteLoader(false);
        loadingMore = false;
      });
  }

  /* ---------- Chips de subcategorías: scroll lateral con la rueda ---------- */
  function initPillsScroll() {
    var pills = document.querySelector('.collection__pills');
    if (!pills) return;
    pills.addEventListener(
      'wheel',
      function (e) {
        if (pills.scrollWidth <= pills.clientWidth) return;
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          pills.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      },
      { passive: false }
    );
  }

  /* ---------- Drawer de filtros ---------- */
  function initDrawer() {
    /* delegado: el botón vive en zona re-renderizable */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-facets-open]')) {
        document.documentElement.classList.add('facets-drawer-open');
        return;
      }
      if (e.target.closest('[data-facets-close]')) {
        document.documentElement.classList.remove('facets-drawer-open');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.documentElement.classList.remove('facets-drawer-open');
      }
    });
  }

  function onFormChange(e) {
    /* feedback inmediato en la casilla tocada (el form NO se re-renderiza) */
    if (e.target.matches('input[type="checkbox"]')) {
      var lab = e.target.closest('label');
      if (lab) lab.classList.toggle('is-active', e.target.checked);
    }
    var isPrice = e.target.matches('input[type="number"]');
    if (isPrice) {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(applyFilters, 600);
    } else {
      applyFilters();
    }
  }

  function buildSearchParams() {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (String(value).trim() !== '') params.append(key, value);
    });
    return params.toString();
  }

  function applyFilters() {
    var qs = buildSearchParams();
    var url = window.location.pathname + (qs ? '?' + qs : '');
    /* el cambio nació en el form: NO reemplazar su HTML (rompe los taps) */
    renderFromUrl(url, true, false);
  }

  /* Actualiza contadores y estados del form sin destruir el DOM
     (reemplazarlo entero hacía perder taps en móvil). */
  function morphFacets(freshForm) {
    /* El form fresco (servidor) solo trae los valores con resultados
       (o el activo). Si una opción NO está en él, da 0 resultados. */
    var counts = {};
    freshForm.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
      var label = inp.closest('label');
      var c = label && label.querySelector('.facets__box-count');
      counts[inp.name + '|' + inp.value] = c ? c.textContent : '';
    });
    form.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
      var label = inp.closest('label');
      if (!label) return;
      var li = label.closest('li');
      var c = label.querySelector('.facets__box-count');
      var key = inp.name + '|' + inp.value;
      var hasResults = Object.prototype.hasOwnProperty.call(counts, key);
      if (c && hasResults) c.textContent = counts[key];
      label.classList.toggle('is-active', inp.checked);
      /* ocultar valores sin resultados (salvo el marcado); reaparecen
         al volver a tener resultados al cambiar la selección */
      if (li) li.style.display = hasResults || inp.checked ? '' : 'none';
    });
  }

  function renderFromUrl(url, push, replaceForm) {
    if (replaceForm === undefined) replaceForm = true;
    if (controller) controller.abort();
    controller = new AbortController();

    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);

    grid.setAttribute('aria-busy', 'true');

    fetch(u.toString(), { signal: controller.signal })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var freshGrid = doc.getElementById('ProductGridContainer');
        if (freshGrid) grid.innerHTML = freshGrid.innerHTML;

        /* Refrescar también la barra de facetas (contadores/badges) */
        var freshForm = doc.getElementById('FacetsForm');
        if (freshForm && form) {
          if (replaceForm) {
            var openLabels = [];
            form.querySelectorAll('[data-facet-group][open] .facets__summary').forEach(function (s) {
              openLabels.push(s.textContent.trim().split('\n')[0]);
            });
            form.innerHTML = freshForm.innerHTML;
            /* restaurar dropdowns abiertos */
            form.querySelectorAll('[data-facet-group]').forEach(function (d) {
              var label = d.querySelector('.facets__summary').textContent.trim().split('\n')[0];
              if (openLabels.indexOf(label) !== -1) d.setAttribute('open', '');
            });
            syncAllSliders();
          } else {
            morphFacets(freshForm);
          }
        }

        grid.removeAttribute('aria-busy');
        attachInfiniteObserver();
        if (window.ObiWishlist) window.ObiWishlist.sync(grid);

        if (push) {
          var clean = new URL(u.toString());
          clean.searchParams.delete('section_id');
          window.history.pushState({}, '', clean.toString());
        }
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          grid.removeAttribute('aria-busy');
          window.location.href = url; // fallback: recarga clásica
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
